export default {
    actions: {
        loadNotes() {
            return this.dispatch('sendRequest', { path: '/note/note', data: {}, method: 'get', formErrors: {} });
        },
        loadNote(state, {id}) {
            return this.dispatch('sendRequest', { path: '/note/note/'+id, data: {}, method: 'get', formErrors: {} });
        },
        createNote(state, {data, formErrors}) {
            return this.dispatch('sendRequest', { path: '/note/note', data, method: 'post', formErrors });
        },
        editNote(state, {data, formErrors, id}) {
            return this.dispatch('sendRequest', { path: '/note/note/'+id, data, method: 'post', formErrors });
        },
        loadList(state, {id}) {
            return this.dispatch('sendRequest', { path: '/note/note/'+id+'/list', method: 'get', formErrors: {} });
        },
        createList(state, {id, data, formErrors}) {
            return this.dispatch('sendRequest', { path: '/note/note/'+id+'/list', data, method: 'post', formErrors });
        },
        editList(state, {id, subId, data, formErrors}) {
            return this.dispatch('sendRequest', { path: '/note/note/'+id+'/list/'+subId, data, method: 'post', formErrors });
        },
        deleteList(state, {id, subId, subSubId}) {
            return this.dispatch('sendRequest', { path: '/note/note/'+id+'/list/'+subId, data: {}, method: 'delete', formErrors: {} });
        },
        changeListSequence(state, {id, subId, data}) {
            return this.dispatch('sendRequest', { path: '/note/note/'+id+'/list/'+subId+'/sequence', data, method: 'post', formErrors: {} });
        },
        changeListStatusNew(state, {id, subId}) {
            return this.dispatch('sendRequest', { path: '/note/note/'+id+'/list/'+subId+'/new', data: {}, method: 'post', formErrors: {} });
        },
        changeListStatusDone(state, {id, subId}) {
            return this.dispatch('sendRequest', { path: '/note/note/'+id+'/list/'+subId+'/done', data: {}, method: 'post', formErrors: {} });
        }
    }
}